/**
 * The "Architect / Designer" lead source, and the name field it reveals.
 *
 * Matched on the stored value: the label is a company's to rename, so a label
 * match would break the moment an admin edits it.
 */
export const LEAD_SOURCE_ARCHITECT = "architect_designer"

export const ARCHITECT_NAME_MAX_LENGTH = 255

export function isLeadSourceArchitect(
  sourceValue: string | null | undefined
): boolean {
  return sourceValue === LEAD_SOURCE_ARCHITECT
}

/**
 * The patch to merge alongside a source change: clears a stale architect name
 * the moment the source stops being Architect / Designer, and leaves it alone
 * (including whatever the user is mid-typing) otherwise.
 */
export function architectNameClearPatch(
  nextSource: string | null | undefined
): { architect_name: null } | Record<string, never> {
  return isLeadSourceArchitect(nextSource) ? {} : { architect_name: null }
}
